import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";
import { Container } from "../zen/Container";
import { Logo } from "../zen/Logo";

const colDivisions = [
    { label: "BIM & Engineering", to: "/bim" },
    { label: "Building Materials", to: "/building-materials" },
    { label: "Real Estate", to: "/real-estate" },
    { label: "Consulting", to: "/consulting" },
];

const colCompany = [
    { label: "About", to: "/divisions" },
    { label: "Contact", to: "/contact" },
    { label: "Careers", to: "/contact" },
    { label: "Press", to: "/contact" },
];

const colLegal = [
    { label: "Privacy Policy", to: "/contact" },
    { label: "Terms", to: "/contact" },
    { label: "Disclaimers", to: "/contact" },
];

const FooterCol = ({ title, items, testIdPrefix }) => (
    <div>
        <h4 className="text-[11px] uppercase tracking-widest-2 text-text-muted">
            {title}
        </h4>
        <ul className="mt-5 space-y-3">
            {items.map((item) => (
                <li key={item.label}>
                    <Link
                        to={item.to}
                        data-testid={`${testIdPrefix}-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-[14px] text-text-secondary hover:text-text-primary transition-colors duration-200"
                    >
                        {item.label}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

export const Footer = () => {
    return (
        <footer
            data-testid="main-footer"
            className="relative border-t border-border-subtle bg-base"
        >
            <Container>
                <div className="grid grid-cols-1 gap-12 py-20 md:grid-cols-12 lg:py-24">
                    <div className="md:col-span-5">
                        <Logo />
                        <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-text-secondary">
                            Engineering. Infrastructure. Execution.
                        </p>
                        <p className="mt-3 max-w-sm text-[14px] leading-relaxed text-text-muted">
                            ZenMe Group LLC operates a portfolio of businesses
                            across engineering services, industrial supply,
                            real estate, and strategic consulting.
                        </p>
                    </div>

                    <div className="md:col-span-7 grid grid-cols-2 gap-10 sm:grid-cols-3">
                        <FooterCol
                            title="Divisions"
                            items={colDivisions}
                            testIdPrefix="footer-div"
                        />
                        <FooterCol
                            title="Company"
                            items={colCompany}
                            testIdPrefix="footer-company"
                        />
                        <FooterCol
                            title="Legal"
                            items={colLegal}
                            testIdPrefix="footer-legal"
                        />
                    </div>
                </div>

                <div className="flex flex-col items-start justify-between gap-6 border-t border-border-subtle py-8 sm:flex-row sm:items-center">
                    <p className="text-[12.5px] text-text-muted inline-flex items-center gap-2">
                        <span
                            aria-hidden
                            className="h-1 w-1 rounded-full bg-[var(--accent)]"
                            style={{ boxShadow: "0 0 8px rgba(124,255,79,0.6)" }}
                        />
                        © 2025 ZenMe Group LLC. All rights reserved.
                    </p>
                    <div className="flex items-center gap-3">
                        <a
                            href="https://www.linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            data-testid="footer-linkedin"
                            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border-subtle text-text-muted transition-colors duration-200 hover:text-text-primary hover:border-border-default"
                        >
                            <Linkedin className="h-4 w-4" strokeWidth={1.5} />
                        </a>
                        <a
                            href="https://x.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="X / Twitter"
                            data-testid="footer-twitter"
                            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border-subtle text-text-muted transition-colors duration-200 hover:text-text-primary hover:border-border-default"
                        >
                            <Twitter className="h-4 w-4" strokeWidth={1.5} />
                        </a>
                        <Link
                            to="/admin/login"
                            data-testid="footer-login-link"
                            className="ml-1 text-[11px] text-text-muted transition-colors duration-200 hover:text-text-secondary"
                            style={{ textDecoration: "none" }}
                        >
                            login
                        </Link>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
